import React, { Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import PrivateRoute from "./private-route";
import AppLayout from "../components/app";
import { routes } from "./layouts-routes";
import { useSelector } from "react-redux";
import AuthRoutes from "./auth-routes";
import Error404 from "../pages/errors/error404";
import ScrollToTop from "../utils/scrollToTop";
import Loader from "../components/common/loader";

const MainRoutes = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<PrivateRoute />}>
            {isAuthenticated ? (
              <>
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="/" element={<Navigate to="dashboard" />} />
              </>
            ) : null}
            {routes.map(({ path, element }, i) => (
              <Route element={<AppLayout />} key={i}>
                <Route path={path} element={element} />
              </Route>
            ))}
          </Route>
          {AuthRoutes()}
          {/* Ruta catch-all para errores 404 */}
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default MainRoutes;
